import type { MessagingChannelsCopy } from './types';

export const EN: MessagingChannelsCopy = {
  title: 'Messaging',
  description:
    'Talk to IMAI from the chat apps you already use. Connect once, then message IMAI there.',
  privacy:
    'Messages from your connected accounts run as you in this workspace and use your credits.',
  loading: 'Loading messaging channels',
  unavailable: 'Not available yet',
  unavailableNote: '{channel} isn’t set up for IMAI yet.',
  connectedBadge: 'Connected',
  cancel: 'Cancel',

  phoneTitle: 'Phone number',
  phoneNote: 'Connect WhatsApp or iMessage with your phone number.',
  phoneUnavailableNote: 'Texting IMAI isn’t set up yet.',
  addNumber: 'Add number',
  countryLabel: 'Country code',
  countrySearch: 'Search country or code…',
  countryEmpty: 'No countries found.',
  numberLabel: 'Phone number',
  numberPlaceholder: 'Phone number',
  numberHint: 'Country not listed? Type the full number starting with +.',
  continueActivation: 'Continue',
  editNumber: 'Change number',
  activateQr: 'Scan and send to connect.',
  activateTitle: 'Send one message on WhatsApp',
  activateHint: 'Tap the button and send the message that’s filled in for you.',
  activateSentFrom: 'Send it from {number}.',
  activateButton: 'Open {channel}',
  activateManual: 'Or send {message} to {number} on WhatsApp.',
  activateWaiting: 'Waiting for your message. Expires in {time}.',
  startAgain: 'Start again',
  verifiedBadge: 'Verified',
  verifiedOn: 'Verified {date}',
  change: 'Change',
  changeAria: 'Change phone number {number}',
  remove: 'Remove',
  removeAria: 'Remove phone number {number}',
  messageImai: 'Message IMAI',
  messageImaiAria: 'Message IMAI on {channel}',
  removeTitle: 'Remove {number}?',
  removeDescription:
    'IMAI will stop answering this number on iMessage and WhatsApp. You can add it again any time.',
  removeError: 'Couldn’t remove the number. Try again.',

  errorInvalidNumber: 'Enter a valid phone number, including the area code.',
  errorNumberTaken: 'This number is already used by another IMAI account.',
  errorRateLimited: 'Too many tries. Wait a while, then try again.',
  errorChannelUnavailable:
    'That option isn’t available right now. Pick the other one.',
  errorSendFailed: 'Couldn’t start verification. Try again.',
  errorActivationExpired: 'This activation expired. Start again.',

  noteSlack: 'Message IMAI from your Slack workspace.',
  noteTeams: 'Message IMAI from Microsoft Teams.',
  noteTelegram: 'Chat with the IMAI bot on Telegram.',
  connect: 'Connect',
  connectAria: 'Connect {channel}',
  connectError: 'Couldn’t start connecting {channel}. Try again.',
  connectedOn: 'Connected {date}',
  accountFallback: 'Your {channel} account',
  installSlack: 'Add IMAI to your workspace',
  installTeams: 'Add IMAI to Teams',
  openTelegram: 'Open in Telegram',
  disconnect: 'Disconnect',
  disconnectAria: 'Disconnect {account} from {channel}',
  disconnectError: 'Couldn’t disconnect {channel}. Try again.',
  disconnectTitle: 'Disconnect {channel}?',
  disconnectDescription:
    'Messages from {account} will stop reaching IMAI. You can connect it again any time.',

  toastConnected: '{channel} connected',
  toastConnectedGeneric: 'Account connected',
  toastErrorExpired: 'That sign-in took too long. Try connecting again.',
  toastErrorInvalidState:
    'That sign-in link isn’t valid anymore. Try connecting again.',
  toastErrorAccountTaken:
    'That account is already connected to another IMAI user.',
  toastErrorNotMember: 'You’re no longer a member of this workspace.',
  toastErrorProvider: 'The sign-in didn’t finish. Try connecting again.',
  toastErrorGeneric: 'Couldn’t connect the account. Try again.',
};
